import React, { MouseEventHandler, useMemo } from 'react';
import clsx from 'clsx';
import Cookies from 'js-cookie';
import {
  Title,
  Typography,
  Button
} from '@npm-registry/eapteka-ui';

import empty from '../../../assets/images/empty.png';
import { text } from '../../../text';
import styles from './EmptyCartPage.scss';
import { useEmptyCartPage } from './hooks/useEmptyCartPage';
import { GoToMainButtonClicked } from '../../../services/dispatchers';
import { COOKIE_REGION_URL } from '../../../consts';

export const EmptyCartPage = () => {
  const {
    description,
    additionalButtonText,
    onClickAdditionalButton
  } = useEmptyCartPage();

  const rootClassNames = useMemo(
    () =>
      clsx([
        styles.root,
        {
          [styles.rootIsHost]: window._eaptekaIsHostMF
        }
      ]),
    []
  );
  const buttonWrapperClassNames = useMemo(
    () =>
      clsx([
        styles.buttonWrapper,
        {
          [styles.buttonWrapperIsDouble]:
            !!additionalButtonText
        }
      ]),
    [additionalButtonText]
  );

  const onClickMain: MouseEventHandler<
    HTMLButtonElement
  > = () => {
    const regionUrl = Cookies.get(COOKIE_REGION_URL) || '/';
    const url = `${regionUrl}`;

    if (window._eaptekaIsHostMF) {
      window.history.pushState({}, '', url);
    } else {
      window.location.assign(url);
    }
    GoToMainButtonClicked.dispatch();
  };

  return (
    <div className={rootClassNames}>
      <Title tag="h1" className={styles.title}>
        {text['cart.header']}
      </Title>
      <main className={styles.main}>
        <div className={styles.image}>
          <img
            src={empty}
            alt={text['cart.empty.header']}
          />
        </div>
        <Typography className={styles.emptyHeader}>
          {text['cart.empty.header']}
        </Typography>
        <Typography className={styles.emptyText}>
          {description}
        </Typography>
        <div className={buttonWrapperClassNames}>
          <Button
            className={styles.button}
            size="s"
            onClick={onClickMain}
          >
            {text['button.goToMain']}
          </Button>
          {additionalButtonText && (
            <Button
              className={styles.button}
              variant="outlinedSolid"
              size="s"
              onClick={onClickAdditionalButton}
            >
              {additionalButtonText}
            </Button>
          )}
        </div>
      </main>
    </div>
  );
};
